module.exports = __webpack_public_path__ + "img/B4.a2ec8818.jpg";